var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.586V13H21V16C21.0001 16.2652 21.1054 16.5195 21.293 16.707L24 19.414V21H2V19.414L4.707 16.707C4.89455 16.5195 4.99994 16.2652 5 16V12C4.99721 10.5948 5.3653 9.21374 6.06709 7.99632C6.76887 6.7789 7.7795 5.76823 8.9969 5.06641C10.2143 4.36458 11.5953 3.99644 13.0005 3.99918C14.4058 4.00192 15.7853 4.37543 17 5.082V2.847C16.0481 2.42552 15.0356 2.15688 14 2.051V0H12V2.05C9.53457 2.30093 7.24976 3.45712 5.58737 5.29498C3.92498 7.13285 3.0031 9.52184 3 12V15.586L0.293 18.293C0.105451 18.4805 5.66374e-05 18.7348 0 19V22C0 22.2652 0.105357 22.5196 0.292893 22.7071C0.48043 22.8946 0.734784 23 1 23H8V24C8 25.3261 8.52678 26.5979 9.46447 27.5355C10.4021 28.4732 11.6739 29 13 29C14.3261 29 15.5979 28.4732 16.5355 27.5355C17.4732 26.5979 18 25.3261 18 24V23H25C25.2652 23 25.5196 22.8946 25.7071 22.7071C25.8946 22.5196 26 22.2652 26 22V19C25.9999 18.7348 25.8946 18.4805 25.707 18.293L23 15.586ZM16 24C16 24.7956 15.6839 25.5587 15.1213 26.1213C14.5587 26.6839 13.7956 27 13 27C12.2044 27 11.4413 26.6839 10.8787 26.1213C10.3161 25.5587 10 24.7956 10 24V23H16V24Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBlack);
export default __webpack_public_path__ + "static/media/notification_black.609c61a1f594066af941c8911052c820.svg";
export { ForwardRef as ReactComponent };